import {
  Box,
  Button,
  Collapse,
  Container,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DownIcon from "@mui/icons-material/ArrowDropDown";
import { collection, db, getDocs } from "../firebaseConfig";

const FAQ = () => {
  const [active, setActive] = useState("All Questions");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleClickDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  // Fetch data from Firestore when the component loads
  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "questions"));
      const questionList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setQuestions(questionList);
      setLoading(false);
    };

    fetchData();
  }, []);

  const filter = [
    { id: "All Questions", label: "All Questions" },
    { id: "Early Childhood", label: "Early Childhood" },
    { id: "Primary", label: "Primary" },
    { id: "Secondary", label: "Secondary" },
  ];

  return (
    <>
      <Box sx={{ width: "100vw", minHeight: "100vh" }}>
        {/* FAQ Header Text Section */}
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "60vh",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 6, md: 0 },
            mb: { xs: 5, md: 0 },
          }}
        >
          <Typography
            variant="h2"
            maxWidth={"350px"}
            my={4}
            textAlign={"center"}
          >
            Frequently <span style={{ color: "#DB5430" }}>Asked</span> Questions
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: "center", width: { xs: "100%", md: "60%" } }}
          >
            Lorem ipsum dolor sit amet consectetur. Ac turpis mi lacinia
            venenatis quis felis in. Eu ante amet felis ut. Lorem cursus eu amet
            egestas laoreet libero nam dignissim diam.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ my: 3 }}>
              {filter.map((filt) => (
                <Button
                  key={filt.id}
                  sx={{
                    backgroundColor:
                      active === filt.id ? "primary.main" : "secondary.light",
                    borderRadius: "50px",
                    py: 1.5,
                    px: 2,
                    mr: 0.5,
                  }}
                  onClick={() => setActive(filt.id)}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textTransform: "none",
                      color:
                        active === filt.id ? "primary.dark" : "secondary.main",
                    }}
                  >
                    {filt.label}
                  </Typography>
                </Button>
              ))}
            </Box>
          </Box>
        </Container>

        {/* Question and Answer Section */}
        <Container sx={{ mb: 20 }}>
          {questions
            .filter(
              (faq) => active === "All Questions" || faq.category === active
            )
            .map((faq) => (
              <Box
                key={faq.id}
                sx={{
                  width: "inherit",
                  backgroundColor: "rgba(219, 84, 48, 0.4)",
                  p: 2,
                  borderRadius: 2,
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: "600" }}>
                    {faq.question}
                  </Typography>
                  <IconButton
                    aria-label="open"
                    sx={{
                      transform:
                        activeDropdown === faq.id
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                    onClick={() => handleClickDropdown(faq.id)}
                  >
                    <DownIcon color="secondary" />
                  </IconButton>
                </Box>
                <Collapse
                  in={activeDropdown === faq.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      bgcolor: "white",
                      borderRadius: 1,
                      boxShadow: 2,
                    }}
                  >
                    <Typography variant="body2">{faq.answer}</Typography>
                  </Box>
                </Collapse>
              </Box>
            ))}
        </Container>
      </Box>
    </>
  );
};

export default FAQ;
